import styled from "styled-components"
import { Colors } from "styles/app-styles"

export const SectionFormRow = styled.div`
  &:nth-child(2n){
    background: ${Colors.inputFocus};
    border: 1px solid ${Colors.towerGrey};
    margin: 10px 0 20px -15px;
    padding: 15px 15px 0 15px;
  }
  h5 {
    color: ${Colors.darkDenim};
    font-family: 'Roboto', sans-serif;
  }
`

export const SectionFormWell = styled(SectionFormRow)`
  background: ${Colors.inputFocus};
  border: 1px solid ${Colors.towerGrey};
  margin: 10px 0 20px -15px;
  padding: 15px 15px 0 15px;
`

export const FormRow = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
  > div {
    display: flex;
    flex-direction: column;
    margin-right: 30px;
  }
`

export const FormSection = styled.div`
  font-family: 'Roboto', sans-serif;
  hr {
    color: ${Colors.towerGrey};
    margin: 10px 0 25px 0 !important;
  }
  label {
    color: ${Colors.blackPearl};
    font-family: 'Roboto-Light', sans-serif;
    font-size: 16px;
    margin-bottom: 10px;
  }
`

export const FormError_s = styled.label`
  background: ${Colors.colorDanger};
  border-radius: 2px;
  color: ${Colors.white} !important;
  font-size: 14px;
  height: 20px;
  line-height: 14px;
  padding: 3px 8px;
`